/**
 * FAQ Accordion JavaScript
 * Performance Optimized & Auto-scroll Fixed
 */

(function() {
  'use strict';

  class FAQAccordion {
    constructor() {
      this.sections = document.querySelectorAll('.faq-accordion[data-section-id]');
      if (this.sections.length === 0) return;

      this.sections.forEach(section => {
        this.initSection(section);
      });
    }

    initSection(section) {
      const items = section.querySelectorAll('[data-faq-item]');
      if (items.length === 0) return;

      // Set first item as open by default
      const firstItem = items[0];
      if (firstItem && firstItem.getAttribute('data-faq-open') === 'true') {
        // GÜNCELLEME 1: Sayfa ilk açıldığında kaydırma yapmaması için 'false' gönderiyoruz
        this.openItem(firstItem, false);
      }

      // Add click listeners
      items.forEach(item => {
        const button = item.querySelector('.faq-accordion__question');
        if (button) {
          button.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleItem(item);
          });
        }
      });

      // Keyboard navigation
      items.forEach(item => {
        const button = item.querySelector('.faq-accordion__question');
        if (button) {
          button.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              this.toggleItem(item);
            }
          });
        }
      });
    }

    toggleItem(item) {
      const isOpen = item.getAttribute('data-faq-open') === 'true';
      
      if (isOpen) {
        this.closeItem(item);
      } else {
        // Close all items first (optional - can be changed to allow multiple open)
        // this.closeAllItems();
        
        // Kullanıcı tıkladığında varsayılan değer (true) devreye girer ve kaydırma yapılır
        this.openItem(item);
      }
    }

    // GÜNCELLEME 2: shouldScroll parametresi eklendi (varsayılan: true)
    openItem(item, shouldScroll = true) {
      const button = item.querySelector('.faq-accordion__question');
      const answer = item.querySelector('.faq-accordion__answer');
      const questionText = item.querySelector('.faq-accordion__question-text');
      const answerContent = item.querySelector('.faq-accordion__answer-content');
      
      if (!button || !answer) return;

      item.setAttribute('data-faq-open', 'true');
      button.setAttribute('aria-expanded', 'true');
      answer.setAttribute('aria-hidden', 'false');
      
      // Force visibility
      item.style.opacity = '1';
      item.style.visibility = 'visible';
      if (questionText) {
        questionText.style.opacity = '1';
        questionText.style.visibility = 'visible';
      }
      if (answerContent) {
        answerContent.style.opacity = '1';
        answerContent.style.visibility = 'visible';
      }
      answer.style.display = 'block';
      answer.style.visibility = 'visible';

      // GÜNCELLEME 3: Kaydırma işlemi şarta bağlandı
      if (shouldScroll) {
        // Smooth scroll to item if it's not fully visible
        setTimeout(() => {
          const rect = item.getBoundingClientRect();
          const isVisible = rect.top >= 0 && rect.bottom <= window.innerHeight;
          
          if (!isVisible) {
            item.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest'
            });
          }
        }, 100);
      }
    }

    closeItem(item) {
      const button = item.querySelector('.faq-accordion__question');
      const answer = item.querySelector('.faq-accordion__answer');
      
      if (!button || !answer) return;

      item.setAttribute('data-faq-open', 'false');
      button.setAttribute('aria-expanded', 'false');
      answer.setAttribute('aria-hidden', 'true');
    }

    closeAllItems(section) {
      const items = section.querySelectorAll('[data-faq-item]');
      items.forEach(item => {
        this.closeItem(item);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new FAQAccordion();
    });
  } else {
    new FAQAccordion();
  }

  // Re-initialize on section load (for Shopify theme editor)
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.detail.sectionId) {
        const section = document.querySelector(`[data-section-id="${event.detail.sectionId}"]`);
        if (section && section.classList.contains('faq-accordion')) {
          new FAQAccordion();
        }
      }
    });
  }
})();